<ng-container *ngIf="!loading">
	<div class="header-padding">
		<div class="header-container">
			<div class="report-info">
				<h2 class="report-title">Blast Design</h2>
				<p class="report-subtitle">
					<span class="subtitle-span">Hole Count & Length</span> - visualizes number of holes, average length of holes,
					average laborers & average hours worked.
				</p>
			</div>
			<div class="export-btn">
				<button mat-raised-button color="primary" class="export-pdf-btn" (click)="pdfDownload()"><mat-icon
						class="svg-icon" svgIcon="pdfIcon"></mat-icon>Export As PDF</button>
			</div>
		</div>
	</div>

	<app-dashboard-chart-group [chartOptions]="chartOptions" [Highcharts]="Highcharts"
		(chartInstance)="onChartInstance($event.chart, $event.index)">
	</app-dashboard-chart-group>
</ng-container>

<ng-container *ngIf="loading">
	<div class="loading-logo">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>